import 'bootstrap';
import { CheckoutService } from '../Checkout/checkoutService';
import { IArvatoGastRequestModel } from '../Checkout/Models/Api/ArvatoGastRequestModel';
import IBillingAddress = CheckoutflowReponse.IBillingAddress;
import IShippingAddress = CheckoutflowReponse.IShippingAddress;
import { addAddressesToCartResultHandling } from '../Checkout/checkoutStep3Gast';
const checkoutService = new CheckoutService();

var modalIndex = 0;
var arvatoModals;
var ChosenAddresses = {} as IArvatoGastRequestModel;

$(window).on('load', function() {
    arvatoModalInit();
});

export function arvatoModalInit() {
    arvatoModals = $('.arvatoModal');
    if (arvatoModals.length > 0) {
        $(arvatoModals[arvatoModals.length - 1]).on('click', '.arvatoSubmit:not(.noReloadOnSubmit)', arvatoSubmit); //nur 'MeineDaten'
        $(arvatoModals).on('click', '.arvatoSubmit.noReloadOnSubmit', arvatoAjax);
        highlightDifferences();
        $(arvatoModals[modalIndex]).modal();
    }
}

/*
 * Hebt die unterschiede zwischen validierter und verifizierter Adresse für den Kunden dick hervor
 * */
function highlightDifferences() {
    for (var i = 0; i < arvatoModals.length; i++) {
        let modal = $(arvatoModals[i]);
        let customerInput = modal.find('.arvatoAddressData.customerInput');
        let arvatoAddress = modal.find('.arvatoAddressData:not(.customerInput)');
        let addressPropsCustomerInput = customerInput.find('span:not(.area)');
        let addressPropsArvato = arvatoAddress.find('span:not(.area)');
        for (var i = 0; i < addressPropsArvato.length; i++) {
            if (addressPropsArvato[i].innerText != addressPropsCustomerInput[i].innerText) {
                addressPropsArvato[i].classList.add('bold');
            }
        }
    }
}

/*
 * Form-Submit für 'MeineDaten'-Adressen
 * */
function arvatoSubmit() {
    let modal = $(this).parents('.arvatoModal');
    let checkedRadio = modal.find('input[name=arvatoRadio]:checked');
    if (checkedRadio.length == 0) {
        return;
    }
    let useArvatoAddress = checkedRadio.val() == 'true';
    if (!useArvatoAddress) {
        let arvatoAddressInput = modal.find('.arvatoAddressInput');
        let customerInputJson = arvatoAddressInput.data('customerinput') as string;
        arvatoAddressInput.val(JSON.stringify(customerInputJson));
    }
    $(this)
        .parents('form')
        .submit();
}

/*
 * Ajax API-Call für 'Checkout-Gast-Neukunde'-Adressen
 * */
function arvatoAjax() {
    let modal = $(this).parents('.arvatoModal');
    let checkedRadio = modal.find('input[name=arvatoRadio]:checked');
    if (checkedRadio.length == 0) {
        return;
    }
    let useArvatoAddress = checkedRadio.val() == 'true';
    let arvatoAddressInput = modal.find('.arvatoAddressInput');
    let addressJson: string;
    let addressType = arvatoAddressInput.data('addresstype');
    if (useArvatoAddress) {
        addressJson = JSON.stringify(arvatoAddressInput.data('arvatoaddress'));
    } else {
        addressJson = JSON.stringify(arvatoAddressInput.data('customerinput'));
    }
    if (addressType == 'billing') {
        ChosenAddresses.billingAddress = JSON.parse(addressJson) as IBillingAddress;
    } else if (addressType == 'shipping') {
        ChosenAddresses.shippingAddress = JSON.parse(addressJson) as IShippingAddress;
    }
    if (modalIndex + 1 == arvatoModals.length) {
        checkoutService
            .AddArvatoAddressesToCart(ChosenAddresses)
            .then(html => {
                addAddressesToCartResultHandling(html);
            })
            .catch(() => {
                modal.modal('hide');
            });
    } else {
        $(arvatoModals[modalIndex]).modal('toggle');
        modalIndex++;
        $(arvatoModals[modalIndex]).modal();
    }
}
